export const CLOSE_EQUIPMENT_SHOP_NARRATIVE = 'closeEquipmentShopNarrative'
export const CONFIRM_SPEEDUP_BUYING_EQUIPMENT = 'confirmSpeedUpBuyingEquipment'
export const TRAINING_HALL_NARRATIVE = 'trainingHallNarrative'
export const CLOSE_TRAINING_HALL_NARRATIVE = 'closeTrainingHallNarrative'
export const AFTER_MATCH_NARRATIVE = 'afterMatchNarrative'
export const FOCUS_CAREER_BUILDING_NARRATIVE = 'focusCareerBuildingNarrative'
